import { initializeApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { publicEnv } from '@/shared/utils/env';

const firebaseConfig = {
  apiKey:            publicEnv.BUN_PUBLIC_FIREBASE_API_KEY,
  authDomain:        publicEnv.BUN_PUBLIC_FIREBASE_AUTH_DOMAIN,
  projectId:         publicEnv.BUN_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket:     publicEnv.BUN_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: publicEnv.BUN_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId:             publicEnv.BUN_PUBLIC_FIREBASE_APP_ID,
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0]!;

export const db = getFirestore(app);
